// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-bar';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.656.576v16.848m7.92-12.96V2.232A.568.568 0 0 0 9 1.656H1.656V5.04H9a.568.568 0 0 0 .576-.576zm6.768 5.688V7.92a.568.568 0 0 0-.576-.576H1.656v3.384h14.04c.36-.072.648-.288.648-.576zm-3.384 5.616v-2.232a.568.568 0 0 0-.576-.576H1.656v3.384h10.656c.36 0 .648-.288.648-.576z'
  />
);

export const viewBox = '0 0 18 18';
